import { useTheme } from 'styled-components';
import useLXDateInputController from '../../../1_application/core/texts/lxDateInputController';
import Row from '../components/box/row';
import SizedBox from '../components/box/sizedBox';
import { LXLabelInput } from './lxInput';

const yearValidate = async (newYear: string) => {
  const numberYear = +newYear;
  if (numberYear < 2050 && numberYear > 1900) {
    return '';
  } else {
    return '< 2050, > 1900';
  }
};

const monthValidate = async (newMonth: string) => {
  const numberMonth = +newMonth;
  if (numberMonth < 13 && numberMonth > 0) {
    return '';
  } else {
    return '< 13, > 0';
  }
};

const dayValidate = async (newDay: string) => {
  const numberDay = +newDay;
  if (numberDay < 32 && numberDay > 0) {
    return '';
  } else {
    return '< 32, > 0';
  }
};

interface LXDateInputProps {
  spacing?: number;
  label?: string;
  widths: number[];
  onDateChange: (date?: Date) => void;
  base?: Date;
  tabIndex?: number;
}

const LXDateInput = (props: LXDateInputProps) => {
  const theme = useTheme();
  const c = useLXDateInputController(props.onDateChange, props.base);

  return (
    <Row>
      <LXLabelInput
        placeholder={'dd'}
        label={props.label ?? theme.texts.dateOfBirth}
        width={props.widths[0] ?? 90}
        value={c.day}
        onValidate={c.setIsDayValid}
        validate={dayValidate}
        onChange={c.setDay}
        validateDelay={10}
        tabIndex={props.tabIndex}
      ></LXLabelInput>
      <SizedBox width={props.spacing ?? 8}></SizedBox>
      <LXLabelInput
        placeholder={'mm'}
        label={''}
        width={props.widths[1] ?? 90}
        value={c.month}
        onValidate={c.setIsMonthValid}
        validate={monthValidate}
        onChange={c.setMonth}
        validateDelay={10}
        tabIndex={props.tabIndex === undefined ? undefined : props.tabIndex + 1}
      ></LXLabelInput>
      <SizedBox width={8}></SizedBox>
      <LXLabelInput
        placeholder={'yyyy'}
        label={''}
        width={props.widths[2] ?? 122}
        value={c.year}
        onValidate={c.setIsYearValid}
        validate={yearValidate}
        onChange={c.setYear}
        validateDelay={10}
        tabIndex={props.tabIndex === undefined ? undefined : props.tabIndex + 2}
      ></LXLabelInput>
    </Row>
  );
};

export default LXDateInput;
